/**
 * @file CookiesPage.tsx
 * @summary Page légale
 *
 * Page de mentions légales / RGPD / CGU / cookies. Conformité Privacy by design — cookies essentiels uniquement.
 *
 * @see docs/07-CODEBASE.md — conventions de code
 * @see docs/02-FRONTEND.md — design system (tokens HSL, typographie)
 */
import LegalPage from "@/components/LegalPage";

export default function CookiesPage() {
  return (
    <LegalPage
      title="Politique de cookies"
      subtitle="Transparence totale sur les traceurs utilisés"
      canonicalPath="/legal/cookies"
      seoTitle="Politique de cookies — CrossFit Chistera (aucun traceur tiers)"
      seoDescription="Politique cookies CrossFit Chistera : aucun cookie publicitaire, aucune mesure d'audience, uniquement des traceurs techniques de session supprimés à la fermeture du navigateur."
      remember={[
        "Aucun cookie publicitaire",
        "Aucun cookie de mesure d'audience",
        "Seuls cookies techniques de session",
        "Supprimés à la fermeture du navigateur",
      ]}
    >
      <h2>Ce que nous n'utilisons pas</h2>
      <ul>
        <li>❌ Cookies publicitaires</li>
        <li>❌ Cookies de mesure d'audience (pas de Google Analytics ni similaire)</li>
        <li>❌ Cookies de profilage</li>
        <li>❌ Cookies de réseaux sociaux (pas de bouton « like » intégré)</li>
      </ul>

      <h2>Cookies techniques nécessaires</h2>
      <p>Le fonctionnement du site peut reposer uniquement sur des traceurs techniques strictement nécessaires (ex. identifiant de session), sans finalité de profilage. Ces cookies sont :</p>
      <ul>
        <li>Déposés le temps de la navigation</li>
        <li>Supprimés à la fermeture du navigateur</li>
        <li>Indispensables au bon fonctionnement du site</li>
        <li>Non transmis à des tiers</li>
      </ul>

      <h2>Gérer votre navigateur</h2>
      <p>Vous pouvez configurer votre navigateur pour refuser les cookies. Cela peut toutefois affecter le fonctionnement du site. Consultez l'aide de votre navigateur pour en savoir plus.</p>

      <p>Voir aussi : <a href="/legal/rgpd">Politique RGPD</a> · <a href="/legal/mentions">Mentions légales</a></p>
    </LegalPage>
  );
}
